import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import theme from "../../theme";
import { Link, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import useButtonStyles from "../../styles/useButtonStyles";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import { APIConstants, APIModuleConstants } from "../../constants/ApiConstants";
import axios from "axios";
import formatDate from "../../util/dateFormat";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import {
  formatDateReport,
  getEncodedLastkey,
  getEncodedValue,
} from "../forms/utility";
import { getHashURL } from "../../util/SearchandFIlters/searchAndFilter";
import { operatorConstants } from "../../util/SearchandFIlters/Constants";
import {
  SearchToolTip,
  filterConstants,
  hashKey,
  DateConstants,
  modelName,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import ExportDialog from "../../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from "../../services/ApiServices/export";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";

interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
}

function SalesListingDetails() {
  const { getUserPermission: getSalesListingPermission } = usePermissionGetter(
    "finance",
    "sales_listing"
  );
  const params = useParams();
  const { orderId } = params;
  const buttonStyles = useButtonStyles();
  const [salesListingData, setSalesListingData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { totalCount, getTotalRecordsCount } = useGetTotalRecords();
  const [openExport, setOpenExport] = useState(false);
  const currentDate = formatDateReport(new Date().toISOString());
  const [sending, setSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [isInitialApiCall, setIsInitalApiCall] = useState(true);
  const searchInputRef = useRef<HTMLInputElement>();
  const [openFilter, setOpenFilter] = useState(false);
  const [filterStates, setFilterStates] = useState<any>([]);
  const [filterActive, setFilterActive] = useState(false);
  const [lastKey, setLastKey] = useState<any>(null);
  const [filterState, setFilterState] = useState({
    createdAt: "",
    VoucherType: "",
    sellingAmountFrom: "",
    sellingAmountTo: "",
    reimbursementAmountFrom: "",
    reimbursementAmountTo: "",
    expiryDate: "",
    utilizedDate: "",
    status: "",
  });

  const resetFilterState = () => {
    setFilterState({
      createdAt: "",
      VoucherType: "",
      sellingAmountFrom: "",
      sellingAmountTo: "",
      reimbursementAmountFrom: "",
      reimbursementAmountTo: "",
      expiryDate: "",
      utilizedDate: "",
      status: "",
    });
    setSalesListingData([]);
    setFilterStates([]);
    setIsInitalApiCall(true);
    setFilterActive(false);
  };

  const sourceList = ["Evouchers", "FlashSales"];
  const statusList = [
    { key: filterConstants.Utilized, value: true },
    { key: filterConstants.Pending, value: false },
  ];

  const columns: TableColumn[] = [
    { key: "orderDate", header: " Order Date" },
    { key: "loyaltyNumber", header: "Loyalty Card No" },
    { key: "itemName", header: "Item Name" },
    { key: "merchant", header: "Merchant" },
    { key: "sourceOfVoucher", header: "Source of Voucher" },
    { key: "itemQuantity", header: "Item Qty" },
    { key: "sellingPrice", header: "Selling Price" },
    { key: "discount", header: "Discount %" },
    { key: "reimbursementCost", header: "Reimbursement Cost" },
    { key: "expiryDate", header: "Expiry Date" },
    { key: "utilizedDate", header: "Utilized Date" },
    { key: "status", header: "Status" },
  ];

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };

  const HandleStatusChange = (event: SelectChangeEvent) => {
    getAllFields(
      filterConstants.Utilized.toLowerCase(),
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };

  const sellingAmount = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    getAllFields(
      "amount",
      `${filterState.sellingAmountFrom},${
        (event.target as HTMLInputElement).value
      }`,
      operatorConstants.between
    );

    setFilterState((prev) => ({
      ...prev,
      sellingAmountTo: (event.target as HTMLInputElement).value,
    }));
  };

  const reimbursementamount = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    getAllFields(
      "reimbursementCost",
      `${filterState.reimbursementAmountFrom},${
        (event.target as HTMLInputElement).value
      }`,
      operatorConstants.between
    );

    setFilterState((prev) => ({
      ...prev,
      reimbursementAmountTo: (event.target as HTMLInputElement).value,
    }));
  };

  const bindSearchAndFilter = (canHaveExistingData?: boolean) => {
    const url = getFilterParams();
    getSalesDetailsData(url, canHaveExistingData);
    setIsInitalApiCall(false);
  };

  useEffect(() => {
    if (isInitialApiCall) bindSearchAndFilter();
  }, [isInitialApiCall]);

  const getSalesDetailsData = async (
    urlString?: string,
    canHaveExistingData?: boolean
  ) => {
    let currentURl = `${process.env.REACT_APP_API_URL}${APIConstants.getSalesListingDetails}?orderId=${orderId}`;
    if (urlString) currentURl += `&${urlString}`;
    const filterText = `filters=order_id:eq:${orderId}`;
    if (lastKey)
      currentURl +=
        (currentURl.includes("?") ? "&" : "?") +
        `${getEncodedLastkey(lastKey)}`;

    try {
      setLoading(true);
      getTotalRecordsCount(APIModuleConstants.salesListingDetails, filterText);
      const deals = await axios.get(currentURl);
      const data = deals.data.result.value;
      const lastDataKey = deals.data.result.lastKey;
      setLastKey(lastDataKey ? lastDataKey : null);
      const mappedData = data.map((earning: any) => ({
        orderDate: earning.createdAt ? formatDate(earning.createdAt) : "-",
        itemName: earning.title ? earning.title : "-",
        loyaltyNumber: earning.loyaltyNo ? earning.loyaltyNo : "-",
        merchant: earning.merchantName ? earning.merchantName : "-",
        sourceOfVoucher: earning.VoucherType ? earning.VoucherType : "-",
        itemQuantity: "1",
        sellingPrice: earning.amount ? earning.amount : "-",
        discount: earning.discount ? earning.discount : "-",
        reimbursementCost:
          earning.reimbursementCost !== "" ? earning.reimbursementCost : "-",
        expiryDate: earning.expiryDate ? formatDate(earning.expiryDate) : "-",
        utilizedDate:
          earning.utilizedDate && earning.utilized
            ? formatDate(earning.utilizedDate)
            : "-",
        status: earning.utilized
          ? filterConstants.Utilized
          : filterConstants.Pending,
      }));
      let completeData = canHaveExistingData
        ? [...salesListingData, ...mappedData]
        : mappedData;
      setSalesListingData(completeData);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      setLastKey(null);
    } finally {
      setLoading(false);
    }
  };

  const headerMapping: Record<string, string> = {
    orderDate: "Order Date",
    loyaltyNumber: "Loyalty Card No",
    itemName: "Item Name",
    merchant: "Merchant",
    sourceOfVoucher: "Source of Voucher",
    itemQuantity: "Item Qty",
    sellingPrice: "Selling Price",
    discount: "Discount %",
    reimbursementCost: "Reimbursement Cost",
    expiryDate: "Expiry Date",
    utilizedDate: "Utilized Date",
    status: "Status",
  };

  const formatCSVData = (data: any[]) => {
    const order = [
      "Order Date",
      "Loyalty Card No",
      "Item Name",
      "Merchant",
      "Source of Voucher",
      "Item Qty",
      "Selling Price",
      "Discount %",
      "Reimbursement Cost",
      "Expiry Date",
      "Utilized Date",
      "Status",
    ];
    function sortByOrder(object: any, order: any) {
      const sortedObject: any = {};
      order?.forEach((key: any) => {
        if (object?.hasOwnProperty(key)) {
          sortedObject[key] = object[key];
        }
      });
      return sortedObject;
    }
    return data?.map((csvRow) => {
      const renamedRow = {
        ...csvRow,
      };
      const excludedColumns = ["navigateTo"];
      for (const key in renamedRow) {
        if (excludedColumns.includes(key)) {
          delete renamedRow[key];
        } else {
          if (headerMapping[key]) {
            renamedRow[headerMapping[key]] = renamedRow[key];
            delete renamedRow[key];
          }
        }
      }
      if (renamedRow.navigateTo) {
        delete renamedRow.id;
      }

      return sortByOrder(renamedRow, order);
    });
  };

  const handleExport = () => {
    setOpenExport(true);
  };
  const handleExportClose = () => {
    setOpenExport(false);
  };
  const handleSearch = () => {
    setSalesListingData([]);
    setIsInitalApiCall(true);
  };

  const handleApply = () => {
    setSalesListingData([]);
    setIsInitalApiCall(true);
    setOpenFilter(false);
    const generatedURL = getFilterParams();
    const searchParams = new URLSearchParams(generatedURL);
    const filtersValue = searchParams.get("filters");
    filtersValue && setFilterActive(true);
  };

  const handleClose = () => {
    setOpenFilter(false);
  };

  const handleLocalDownload = () => {
    const exportableData = formatCSVData(salesListingData);

    if (exportableData.length > 0) {
      const fields = Object.keys(exportableData[0]);
      const csvRows = [fields.join(",")];

      for (const row of exportableData) {
        const values = fields.map((field) => JSON.stringify(row[field]));
        csvRows.push(values.join(","));
      }

      const csvContent = `Report Title: Sales Listing Details Data \nExport Date: ${currentDate}\n${csvRows.join(
        "\n"
      )}`;
      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "sales-listing-details.csv";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else {
      console.error("No data to export");
    }
  };

  const getFilterParams = () => {
    const value = searchInputRef.current
      ? getEncodedValue(searchInputRef.current?.value)
      : "";
    const searchParam = value !== "" ? [value] : [];
    const params = {
      searchData: searchParam,
      filterData: filterStates,
    };
    const url = getHashURL(params);
    return url;
  };

  const handleSendExport = async () => {
    const order_filter = `order_id:eq:${orderId}`;
    const filter = `${
      getFilterParams() ? `${getFilterParams()}*` : "filters="
    }${order_filter}`;

    setSending(true);
    const handleExportFun = await exportData(
      filter,
      modelName.utilizedVouchers,
      hashKey.orderId,
      `${orderId}`
    );
    handleExportFun.data.status && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };
  return (
    <Grid
      borderRadius={4}
      sx={{ background: theme.color?.background, overflow: "hidden" }}
    >
      <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
        <Grid sx={{ width: "484px", py: 4, px: 2 }}>
          <DialogTitle
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thicker,
              }}
            >
              Filter
            </Typography>
            <IconButton
              onClick={() => {
                setOpenFilter(false);
              }}
            >
              <CloseOutlinedIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
            <Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={3} pb={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Order Date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "80%",
                    }}
                    type="date"
                    size="small"
                    placeholder="Order Date"
                    value={filterState.createdAt}
                    onChange={(e) => {
                      getAllFields(
                        "createdAt",
                        new Date(e.target.value).getTime(),
                        operatorConstants.equal
                      );
                      setFilterState((prev) => ({
                        ...prev,
                        createdAt: e.target.value,
                      }));
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid borderBottom={theme.border?.smallGrey} mt={5} pb={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Source of voucher
                </Typography>
                <Grid
                  gap={2}
                  mt={2}
                  display={"flex"}
                  sx={{
                    width: "80%",
                  }}
                >
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{
                      with: "100%",
                    }}
                  >
                    <Select
                      id=""
                      value={filterState.VoucherType}
                      onChange={(e) => {
                        getAllFields(
                          "VoucherType",
                          e.target.value,
                          operatorConstants.equal
                        );
                        setFilterState((prev) => ({
                          ...prev,
                          VoucherType: e.target.value,
                        }));
                      }}
                    >
                      {sourceList.map((name: any) => (
                        <MenuItem value={name}>{name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid borderBottom={theme.border?.smallGrey} mt={3} pb={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                    marginBottom: "4px",
                  }}
                >
                  Selling Price ($)
                </Typography>

                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={6} textAlign="left">
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: theme.font?.fontSize.medium,
                        fontWeight: theme.font?.fontWeight.slightThick,
                      }}
                    >
                      From
                    </Typography>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "100%",
                      }}
                      type="text"
                      size="small"
                      value={filterState.sellingAmountFrom}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          sellingAmountFrom: e.target.value,
                        }))
                      }
                      InputLabelProps={{
                        shrink: true,
                        focused: true,
                        style: {
                          color: "black",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} textAlign="left">
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: theme.font?.fontSize.medium,
                        fontWeight: theme.font?.fontWeight.slightThick,
                      }}
                    >
                      To
                    </Typography>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "100%",
                      }}
                      type="text"
                      size="small"
                      value={filterState.sellingAmountTo}
                      onChange={(e) => {
                        sellingAmount(e);
                      }}
                      InputLabelProps={{
                        shrink: true,
                        focused: true,
                        style: {
                          color: "black",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid borderBottom={theme.border?.smallGrey} mt={3} pb={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                    marginBottom: "4px",
                  }}
                >
                  Reimbursement Cost
                </Typography>

                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={6} textAlign="left">
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: theme.font?.fontSize.medium,
                        fontWeight: theme.font?.fontWeight.slightThick,
                      }}
                    >
                      From
                    </Typography>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "100%",
                      }}
                      type="text"
                      size="small"
                      value={filterState.reimbursementAmountFrom}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          reimbursementAmountFrom: e.target.value,
                        }))
                      }
                      InputLabelProps={{
                        shrink: true,
                        focused: true,
                        style: {
                          color: "black",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} textAlign="left">
                    <Typography
                      sx={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: theme.font?.fontSize.medium,
                        fontWeight: theme.font?.fontWeight.slightThick,
                      }}
                    >
                      To
                    </Typography>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "100%",
                      }}
                      type="text"
                      size="small"
                      value={filterState.reimbursementAmountTo}
                      onChange={(e) => {
                        reimbursementamount(e);
                      }}
                      InputLabelProps={{
                        shrink: true,
                        focused: true,
                        style: {
                          color: "black",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid borderBottom={theme.border?.smallGrey} mt={3} pb={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Expiry date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "80%",
                    }}
                    type="date"
                    size="small"
                    placeholder="Expiry Date"
                    value={filterState.expiryDate}
                    onChange={(e) => {
                      getAllFields(
                        "expiryDate",
                        new Date(e.target.value).getTime(),
                        operatorConstants.equal
                      );
                      setFilterState((prev) => ({
                        ...prev,
                        expiryDate: e.target.value,
                      }));
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid borderBottom={theme.border?.smallGrey} mt={3} pb={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Utilized date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "80%",
                    }}
                    type="date"
                    size="small"
                    placeholder="Utilized Date"
                    value={filterState.utilizedDate}
                    onChange={(e) => {
                      getAllFields(
                        "utilizedDate",
                        new Date(e.target.value).getTime(),
                        operatorConstants.equal
                      );
                      setFilterState((prev) => ({
                        ...prev,
                        utilizedDate: e.target.value,
                      }));
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid mt={3} pb={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Status
                </Typography>
                <Grid
                  gap={2}
                  mt={2}
                  display={"flex"}
                  sx={{
                    width: "80%",
                  }}
                >
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{
                      with: "100%",
                    }}
                  >
                    <Select
                      id=""
                      value={filterState.status}
                      onChange={HandleStatusChange}
                    >
                      {statusList.map((name: any) => (
                        <MenuItem value={name.value}>{name.key}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ pr: 4, gap: 1, pt: 2 }}>
            <Button
              sx={{ ...buttonStyles.outlinedSecondary }}
              onClick={() => {
                resetFilterState();
              }}
            >
              Reset
            </Button>
            <Button
              sx={{ ...buttonStyles.containedSecondary }}
              onClick={handleApply}
            >
              Apply
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>

      <ExportDialog
        closeDialog={setOpenExport}
        emailSent={emailSent}
        exportTitle="Sales Listing Details"
        handleClose={handleExportClose}
        open={openExport}
        sending={sending}
        handleSendExport={handleSendExport}
      />
      <Grid
        height={"6.5rem"}
        borderBottom={theme.border?.newGreyBorder}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={4}
      >
        <Grid display={"flex"} alignItems={"center"} gap={2}>
          <Button
            component={Link}
            to="/finance?tab=earnings"
            sx={{ color: theme.color?.newFilterGrey }}
          >
            <ArrowBackIosIcon />
          </Button>
          <Typography
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              color: theme.color?.newTextColor,
              fontSize: theme.font?.fontSize.large,
              fontWeight: theme.font?.fontWeight.thick,
            }}
          >
            {orderId}
          </Typography>
        </Grid>
        <Grid
          display={"flex"}
          gap={1}
          justifyContent={"end"}
          alignItems={"center"}
          px={2}
        >
          {getSalesListingPermission("export") && (
            <CommonButton
              buttonTitle="Export"
              variant="text"
              color="secondary"
              onClick={handleExport}
              disabled={!salesListingData.length}
            />
          )}
          {/* { need permissions <Button
            sx={{ ...buttonStyles.textSecondary }}
            onClick={handleExport}
            disabled={!salesListingData.length}
          >
            Export
          </Button>} */}
          <Button
            onClick={handleLocalDownload}
            sx={{
              ...buttonStyles.textSecondary,
            }}
            endIcon={<DownloadForOfflineRoundedIcon />}
          >
            Download
          </Button>
          <SearchInput
            HelpTip={SearchToolTip.SalesDetails}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
          <Button
            variant="text"
            startIcon={
              filterActive ? (
                <FilterAltIcon sx={{ color: theme.color?.secondary }} />
              ) : (
                <FilterAltOutlinedIcon />
              )
            }
            sx={{
              color: theme.color?.newFilterGrey,
              textTransform: "capitalize",
            }}
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            Filter
          </Button>
        </Grid>
      </Grid>
      <Grid height={"80%"} p={3}>
        <InfiniteTable
          header={columns}
          contentItems={salesListingData}
          hasMoreRecords={lastKey !== null}
          isInitialLoading={salesListingData.length === 0 && loading}
          fetchMoreData={() => bindSearchAndFilter(true)}
          totalRecords={totalCount}
        />
      </Grid>
    </Grid>
  );
}

export default SalesListingDetails;
